/**
 * ModuleMD PatientPortal API
 * ModuleMD PatientPortal API service
 *
 * OpenAPI spec version: 1.0.0
 * Contact: emrsupport@modulemd.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration } from '../configuration';
import { environment } from '../../environments/environment';


@Injectable()
export class SendMessageFromPatientPortalToPracticeService {

    protected basePath = environment.appSetting.apiUrl+'patientportal';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Referenced to SOA.SendMessageFromPatientPortalToPractice
     * This API sends MessageFromPatientPortalToPractice
     * @param practiceId Integer type ID for practiceId
     * @param patientId Integer type ID for patientId
     * @param messageTypeId Integer type ID for messageTypeId
     * @param messageSubject Subject for Mail
     * @param messageBody Message body for Mail
     * @param senderUserId Integer type ID for senderUserId
     * @param senderUserName Sender name for mail
     * @param senderRoleId Integer type ID for senderRoleId
     * @param sendMessage check the sent status
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendMessageFromPatientPortalToPractice(practiceId: number, patientId: number, messageTypeId: number, messageSubject: string, messageBody: string, senderUserId: number, senderUserName: string, senderRoleId: number, sendMessage: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public sendMessageFromPatientPortalToPractice(practiceId: number, patientId: number, messageTypeId: number, messageSubject: string, messageBody: string, senderUserId: number, senderUserName: string, senderRoleId: number, sendMessage: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public sendMessageFromPatientPortalToPractice(practiceId: number, patientId: number, messageTypeId: number, messageSubject: string, messageBody: string, senderUserId: number, senderUserName: string, senderRoleId: number, sendMessage: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public sendMessageFromPatientPortalToPractice(practiceId: number, patientId: number, messageTypeId: number, messageSubject: string, messageBody: string, senderUserId: number, senderUserName: string, senderRoleId: number, sendMessage: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (practiceId === null || practiceId === undefined) {
            throw new Error('Required parameter practiceId was null or undefined when calling sendMessageFromPatientPortalToPractice.');
        }

        if (patientId === null || patientId === undefined) {
            throw new Error('Required parameter patientId was null or undefined when calling sendMessageFromPatientPortalToPractice.');
        }

        if (messageTypeId === null || messageTypeId === undefined) {
            throw new Error('Required parameter messageTypeId was null or undefined when calling sendMessageFromPatientPortalToPractice.');
        }

        if (messageSubject === null || messageSubject === undefined) {
            throw new Error('Required parameter messageSubject was null or undefined when calling sendMessageFromPatientPortalToPractice.');
        }

        if (messageBody === null || messageBody === undefined) {
            throw new Error('Required parameter messageBody was null or undefined when calling sendMessageFromPatientPortalToPractice.');
        }

        if (senderUserId === null || senderUserId === undefined) {
            throw new Error('Required parameter senderUserId was null or undefined when calling sendMessageFromPatientPortalToPractice.');
        }

        if (senderUserName === null || senderUserName === undefined) {
            throw new Error('Required parameter senderUserName was null or undefined when calling sendMessageFromPatientPortalToPractice.');
        }

        if (senderRoleId === null || senderRoleId === undefined) {
            throw new Error('Required parameter senderRoleId was null or undefined when calling sendMessageFromPatientPortalToPractice.');
        }

        if (sendMessage === null || sendMessage === undefined) {
            throw new Error('Required parameter sendMessage was null or undefined when calling sendMessageFromPatientPortalToPractice.');
        }

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            //formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (practiceId !== undefined) {
            formParams = formParams.append('practiceId', <any>practiceId) || formParams;
        }
        if (patientId !== undefined) {
            formParams = formParams.append('patientId', <any>patientId) || formParams;
        }
        if (messageTypeId !== undefined) {
            formParams = formParams.append('messageTypeId', <any>messageTypeId) || formParams;
        }
        if (messageSubject !== undefined) {
            formParams = formParams.append('messageSubject', <any>messageSubject) || formParams;
        }
        if (messageBody !== undefined) {
            formParams = formParams.append('messageBody', <any>messageBody) || formParams;
        }
        if (senderUserId !== undefined) {
            formParams = formParams.append('senderUserId', <any>senderUserId) || formParams;
        }
        if (senderUserName !== undefined) {
            formParams = formParams.append('senderUserName', <any>senderUserName) || formParams;
        }
        if (senderRoleId !== undefined) {
            formParams = formParams.append('senderRoleId', <any>senderRoleId) || formParams;
        }
        if (sendMessage !== undefined) {
            formParams = formParams.append('sendMessage', <any>sendMessage) || formParams;
        }

        return this.httpClient.post<number>(`${this.basePath}/SendMessageFromPatientPortalToPractice`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
